const pad2 = (n: number): string => String(n).padStart(2, "0");

export function formatDate(value: string): string {
  if (!value) return value;

  if (value.length === 8) {
    return `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`;
  }

  const parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    return `${pad2(parsed.getDate())}/${pad2(parsed.getMonth() + 1)}/${parsed.getFullYear()}`;
  }

  return value;
}

export function maskUrl(url: string): string {
  if (!url) return url;
  const stripped = url.replace(/^https?:\/\//, "");
  if (stripped.length <= 45) return stripped;
  return `${stripped.slice(0, 30)}…${stripped.slice(-10)}`;
}

export function formatDateTime(value: string): string {
  if (!value) return value;

  if (value.length === 14) {
    return `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)} às ${value.slice(8, 10)}:${value.slice(10, 12)}`;
  }

  const parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    return `${pad2(parsed.getDate())}/${pad2(parsed.getMonth() + 1)}/${parsed.getFullYear()} às ${pad2(parsed.getHours())}:${pad2(parsed.getMinutes())}`;
  }

  return value;
}
